import type { ReactNode } from 'react'
/**
 * linkifyText takes a string and returns an array of React nodes where
 * URLs and markdown-style links [#text](url) are replaced with clickable
 * <a> tags that open in a new tab.
 */
const URL_REGEX = /(https?:\/\/[^\s<>"']+)/gi
// Match markdown links like [#Title](url) or [text](url)
const MD_LINK_REGEX = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/gi

export function linkifyText(text: string | null | undefined) {
  if (!text) return text
  // Combined regex: matches markdown links OR plain URLs
  const COMBINED = new RegExp(
    `\\[([^\\]]+)\\]\\((https?:\\/\\/[^\\s)]+)\\)` + // markdown link group
    `|(https?:\\/\\/[^\\s<>"']+)`, // plain url group
    'gi'
  )
  const parts: ReactNode[] = []
  let lastIndex = 0
  let match
  let i = 0
  while ((match = COMBINED.exec(text)) !== null) {
    // Push preceding text
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    if (match[1] && match[2]) {
      // Markdown link: [#text](url)
      parts.push(
        <a
          key={i++}
          href={match[2]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#58a6ff', textDecoration: 'underline', wordBreak: 'break-all' }}
        >
          {match[1]}
        </a>
      )
    } else if (match[3]) {
      // Plain URL
      parts.push(
        <a
          key={i++}
          href={match[3]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#58a6ff', textDecoration: 'underline', wordBreak: 'break-all' }}
        >
          {match[3]}
        </a>
      )
    }
    lastIndex = match.index + match[0].length
  }
  // Push remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }
  return parts.length > 0 ? parts : text
}
